import { devtools } from 'zustand/middleware';
import { create, StateCreator } from 'zustand';

export type DrawerStoreType<T = any> = {
  isOpen: boolean;
  onClose: () => void;
  onOpen: (type: string, data: T) => void;
  type?: string;
  loading?: boolean;
  onChangeLoading: (loading: boolean) => void;
  data?: T;
};

const drawerStoreInitial = {
  isOpen: false,
  type: undefined,
  data: undefined,
  loading: false,
};

const createDrawerStore: StateCreator<DrawerStoreType<any>> = (set) => ({
  ...drawerStoreInitial,
  onClose: () => set({ isOpen: false, type: undefined, data: undefined }),
  onOpen: (type: string, data: any) => set({ isOpen: true, type, data }),
  onChangeLoading: (loading: boolean) => set({ loading }),
});

export const DrawerStore = create<DrawerStoreType<any>>()(devtools(createDrawerStore));
